import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccessControlDeviceState {
  id: any;
  name: any;
  cameraReference: any;
  portReference: any;
  props: {
    [key: string]: any;
  };
}

const initialState: AccessControlDeviceState = {
  id: '',
  name: '',
  cameraReference: '',
  portReference: '',
  props: { isModalVisible: false, refresh: false, searchTerm: '', skip: 1, take: 10, totalItems: 0 },
};

const accessControlDeviceSlice = createSlice({
  name: 'accessControlDevice',
  initialState,
  reducers: {
    setAccessControlDevice: (state, action: PayloadAction<Partial<AccessControlDeviceState>>) => {
      return { ...state, ...action.payload };
    },

    resetProps: (_state, action: PayloadAction<Partial<AccessControlDeviceState['props']> | undefined>) => {
      return {
        ...initialState,
        props: { ...initialState.props, ...action.payload },
      };
    },

    updateField: (state: AccessControlDeviceState, action: PayloadAction<{ field: any; value: any }>) => {
      const { field, value } = action.payload;
      (state as any)[field] = value;
    },

    updateProps: (state, action: PayloadAction<{ field: string; value: any }>) => {
      const { field, value } = action.payload;
      state.props = {
        ...state.props,
        [field]: value,
      };
    },
  },
});

export const { setAccessControlDevice, resetProps, updateField, updateProps } = accessControlDeviceSlice.actions;

export default accessControlDeviceSlice.reducer;
